import React from 'react';
import ContextHelpButton from './ContextHelpButton';

/**
 * Compact list-page control that opens the advanced filters drawer.
 * Sit this at the end of `.preset-buttons` so it matches Quick Filter height.
 * Highlight when extra (drawer-only) filters are applied — no count badge.
 */
function MoreFiltersButton({
  isOpen = false,
  hasAdditional = false,
  onClick,
  onHelpClick,
  helpTitle = 'Learn how filters work (AND/OR logic)',
}) {
  const className = [
    'advanced-filters-btn',
    isOpen ? 'is-open' : '',
    hasAdditional ? 'has-filters' : '',
  ].filter(Boolean).join(' ');

  return (
    <div className="more-filters-cluster">
      <button
        type="button"
        className={className}
        onClick={onClick}
        aria-expanded={Boolean(isOpen)}
        title={hasAdditional ? 'Additional filters applied' : 'More filters'}
      >
        <svg
          className="advanced-filters-icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
        </svg>
        More filters
        <span className={`advanced-arrow${isOpen ? ' open' : ''}`} aria-hidden="true">▼</span>
      </button>
      {typeof onHelpClick === 'function' && (
        <ContextHelpButton
          onClick={onHelpClick}
          title={helpTitle}
          aria-label="Filter help"
        />
      )}
    </div>
  );
}

export default MoreFiltersButton;
